import React from 'react';
import { Column } from '../../../components/layout/grid';
import styles from '../../../styles/widgets/my-plan/plan-doughnuts.module.scss';
import { PlanDoughnuts as Component } from '../../components/doughnuts';
import { Sticky } from '../../../components/layout/sticky';

export const PlanDoughnuts = props => (
  <Column className={styles.doughnuts} renderAs={Sticky} edge>
    <Component {...props} />
  </Column>
);
